import React, { useEffect } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  TextField,
  Button,
  FormLabel
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { NavLink as RouterLink } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { kmMessages } from "src/constant/Messages";
import { Skeleton } from "@material-ui/lab";
import UserAndDate from "src/components/common/UserAndDate"

const emailMaxLength = 100;

const formValidation = {
  required: kmMessages.error.form_validation.field_required,
  pattern: `${kmMessages.error.form_validation.field_wrongemail}`
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const Form = ({ onSubmit, emailConfig, ...rest }) => {
  const classes = useStyles();

  const { handleSubmit, setValue, control, errors } = useForm();

  useEffect(() => {
    if (emailConfig) {
      setValue("email", emailConfig.configValue);
    }
    return () => {};
  }, [emailConfig]);

  const resetEmailValue = () => {
    setValue("email", emailConfig.configValue);
  }

  return (
    <Card className={clsx(classes.root)} {...rest}>
        <Box component="main">
          <Grid container className={classes.root}>
            <Grid item xs={12} elevation={2}>
              <form onSubmit={handleSubmit(onSubmit)}>
                {emailConfig ? (
                  <FormControl
                    fullWidth
                    className={classes.formcontrol}
                  >
                    <Controller
                      as={
                        <TextField
                          error={errors.email ? true : false}
                          id="email"
                          name="email"
                          label="E-mail"
                          placeholder="E-mail"
                          helperText={
                            errors.email &&
                            (
                              formValidation[errors.email.type] || ""
                            ).replaceAll("{maxlen}", emailMaxLength)
                          }
                        />
                      }
                      name="email"
                      defaultValue=""
                      control={control}
                      rules={{
                        required: true,
                        maxLength: emailMaxLength,
                        pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      }}
                    />
                  </FormControl>
                ) : (
                  <Skeleton />
                )}
                {emailConfig ? (
                  <FormControl fullWidth className={classes.formcontrol}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} sm={6}>
                        <FormLabel
                          className={classes.paddingBottom}
                          component="label"
                        >
                          Kto i kiedy utworzył
                        </FormLabel>
                        <UserAndDate variant='body1'
                          username={
                            emailConfig.createdBy
                          }
                          date={emailConfig.createdAt}
                          separator=", "
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} sm={6}>
                        <FormLabel
                          className={classes.paddingBottom}
                          component="label"
                        >
                          Kto i kiedy modyfikował
                        </FormLabel>
                        <UserAndDate variant='body1'
                          username={
                            emailConfig.updatedBy
                          }
                          date={emailConfig.updatedAt}
                          separator=", "
                        />
                      </Grid>
                    </Grid>
                  </FormControl>
                ) : (
                  <Skeleton />
                )}
                <Box className={classes.paddingtop}>
                   <Button
                    color="primary"
                    variant="contained"
                    className={classes.button}
                    endIcon={<SaveIcon />}
                    type="submit"
                  >
                    Zapisz
                  </Button>
                </Box>
              </form>
            </Grid>
          </Grid>
        </Box>
    </Card>
  );
};

export default Form;
